import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

/** Una fila de ServicesTable. `nombre` es el interno (el de los correos de
 *  solicitud); `web_nombre` y `web_desc`, lo que se ha escrito en el CRM para la
 *  web. Sin ellos, la web enseña sus textos de siempre. */
export interface ServicioWeb {
  service_id: string;
  nombre: string;
  segmento: 'propietario' | 'inquilino' | 'comprador' | 'inversor' | 'retirado';
  activo: boolean;
  requiere_cuenta: boolean;
  primer_uso_libre?: boolean;
  web_nombre?: string;
  web_desc?: string;
}

export function useServicios() {
  return useQuery<ServicioWeb[]>({
    queryKey: ['servicios'],
    queryFn: async () => (await api.get('/crm/services')).data.items,
  });
}

export function useGuardarServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ service_id, ...cambios }: Partial<ServicioWeb> & { service_id: string }) =>
      (await api.put(`/crm/services/${service_id}`, cambios)).data as ServicioWeb,
    onSuccess: (s) =>
      qc.setQueryData<ServicioWeb[]>(['servicios'], (lista) =>
        lista?.map((x) => (x.service_id === s.service_id ? s : x)),
      ),
  });
}
